<ag-global-menu class="menu" *ngIf="useLayout"></ag-global-menu>
<ag-global-header class="header" *ngIf="useLayout"></ag-global-header>
<div class="subheader">
  <ag-global-cheader class="cheader" *ngIf="useLayout"></ag-global-cheader>
  <ag-global-gyoseki-management-header class="yomi" *ngIf="useLayout && displayGyosekiManagementHeader"></ag-global-gyoseki-management-header>
  <ag-global-ra-gyoseki-management-header class="yomi" *ngIf="useLayout && displayRaGyosekiManagementHeader"></ag-global-ra-gyoseki-management-header>
</div>
<div class="content" [class.content--full]="!useLayout">
  <ng-content></ng-content>
</div>
